export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-4.png?9460161f94f63959520f0051c5c631a2";